/** This private fork's name and mark, top left of the dashboard. */

import "../wrapped/wrapped.css";

/** The logo: a chat bubble with bars rising inside it, the tallest one Wrapped yellow. */
export function Mark({ size = 30 }: { size?: number }) {
  return (
    <svg viewBox="0 0 32 32" width={size} height={size} aria-hidden className="shrink-0">
      <path
        d="M9 2.5h14a6.5 6.5 0 0 1 6.5 6.5v8.5a6.5 6.5 0 0 1-6.5 6.5H13.5L7.6 28.9a.9.9 0 0 1-1.5-.7V23.7A6.5 6.5 0 0 1 2.5 17.5V9A6.5 6.5 0 0 1 9 2.5z"
        style={{ fill: "var(--wr-blurple)" }}
      />
      <rect x="8" y="13" width="4" height="6.5" rx="1.6" style={{ fill: "var(--wr-white)" }} />
      <rect x="14" y="9.5" width="4" height="10" rx="1.6" style={{ fill: "var(--wr-white)" }} />
      <rect x="20" y="6" width="4" height="13.5" rx="1.6" style={{ fill: "var(--wr-yellow)" }} />
    </svg>
  );
}

export function Brand() {
  return (
    <p
      className="flex items-center gap-2 leading-none text-[var(--color-text)]"
      style={{ fontFamily: "var(--wr-font-display)", fontWeight: 800, fontStretch: "75%", fontSize: 30, letterSpacing: "-0.02em" }}
    >
      <Mark />
      <span className="flex items-start">
        PotatoStats
        <span className="ml-0.5 text-[13px] font-semibold text-[var(--color-muted)]">™</span>
      </span>
    </p>
  );
}
